import React from 'react';

const Arrow: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 62">
      <path
        fill="currentColor"
        d="M10.91,57.51A5,5,0,0,1,7.4,49L25.87,30.56,7.4,12.09a5,5,0,0,1,7-7l22,22a5,5,0,0,1,0,7l-22,22A4.94,4.94,0,0,1,10.91,57.51Z"
      />
    </svg>
  );
};
export default Arrow;
